function numeroSottoCento(numero) {
    const unita = [
        "",
        "uno",
        "due",
        "tre",
        "quattro",
        "cinque",
        "sei",
        "sette",
        "otto",
        "nove",
        "dieci",
        "undici",
        "dodici",
        "tredici",
        "quattordici",
        "quindici",
        "sedici",
        "diciassette",
        "diciotto",
        "diciannove"
    ];

    const decine = [
        "",
        "",
        "venti",
        "trenta",
        "quaranta",
        "cinquanta",
        "sessanta",
        "settanta",
        "ottanta",
        "novanta"
    ];

    if (numero < 20) {
        return unita[numero];
    }

    const decina = Math.floor(numero / 10);
    const unitaNumero = numero % 10;

    let testoDecina = decine[decina];

    // Ventuno, ventotto, trentuno, trentotto...
    if (unitaNumero === 1 || unitaNumero === 8) {
        testoDecina = testoDecina.slice(0, -1);
    }

    return testoDecina + unita[unitaNumero];
}

function numeroSottoMille(numero) {
    if (numero < 100) {
        return numeroSottoCento(numero);
    }

    const centinaia = Math.floor(numero / 100);
    const resto = numero % 100;

    let testo;

    if (centinaia === 1) {
        testo = "cento";
    } else {
        testo = numeroSottoCento(centinaia) + "cento";
    }

    /*
     * Davanti a ottanta e ottocento si elimina la "o" di cento:
     * centottanta, duecentottanta...
     */
    if (resto >= 80 && resto < 90) {
        testo = testo.slice(0, -1);
    }

    return testo + numeroSottoCento(resto);
}

function numeroInteroInLettere(numero) {
    numero = Math.trunc(Number(numero));

    if (!Number.isFinite(numero) || numero < 0) {
        throw new Error("Il numero deve essere un intero positivo");
    }

    if (numero === 0) {
        return "zero";
    }

    if (numero < 1000) {
        return numeroSottoMille(numero);
    }

    if (numero < 1000000) {
        const migliaia = Math.floor(numero / 1000);
        const resto = numero % 1000;

        const testoMigliaia =
            migliaia === 1
                ? "mille"
                : numeroSottoMille(migliaia) + "mila";

        return testoMigliaia + numeroSottoMille(resto);
    }

    if (numero < 1000000000) {
        const milioni = Math.floor(numero / 1000000);
        const resto = numero % 1000000;

        const testoMilioni =
            milioni === 1
                ? "unmilione"
                : numeroInteroInLettere(milioni) + "milioni";

        return testoMilioni + numeroInteroInLettere(resto);
    }

    if (numero < 1000000000000) {
        const miliardi = Math.floor(numero / 1000000000);
        const resto = numero % 1000000000;

        const testoMiliardi =
            miliardi === 1
                ? "unmiliardo"
                : numeroInteroInLettere(miliardi) + "miliardi";

        return testoMiliardi + numeroInteroInLettere(resto);
    }

    throw new Error("Importo troppo elevato");
}

function normalizzaImporto(importo) {
    if (typeof importo === "number") {
        return importo;
    }

    let valore = String(importo).trim();

    if (valore === "") {
        return NaN;
    }

    /*
     * Gestisce sia:
     * 1.234,56
     * 1234,56
     * 1234.56
     */
    if (valore.includes(",")) {
        valore = valore
            .replace(/\./g, "")
            .replace(",", ".");
    }

    return Number(valore);
}

export default function importoInLettere(importo) {
    const valore = normalizzaImporto(importo);

    if (!Number.isFinite(valore) || valore < 0) {
        return "";
    }

    /*
     * Lavoriamo in centesimi per evitare problemi come:
     * 10.10 * 100 = 1009.999999...
     */
    const totaleCentesimi = Math.round(valore * 100);

    const euro = Math.floor(totaleCentesimi / 100);
    const centesimi = totaleCentesimi % 100;

    return (
        numeroInteroInLettere(euro) +
        "," +
        String(centesimi).padStart(2, "0")
    );
}